export default __webpack_public_path__ + "static/media/showOperativeCode.3156ecce.png";